// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1yIA8","label":"CategoryService_label__3TN3l","location":"CategoryService_location__1pM_5"};